import Vue from 'vue'
import Vuex from 'vuex'
import { firebaseMutations } from 'vuexfire'
import { firebaseAction } from 'vuexfire'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    summaryTransactions: [],
    accounts: [],
    students: [],
    staff: [],
    user: null,
    accountsLoading: true,
    archivedAccounts: [],
    archivedAccountsLoading: true,
    currentAccount: null,
    currentAccountTransactions: [],
    currentAccountLoading: true,
    monthlyLoading: false,
    monthlyTransactions: [],
    denied: false
  },
  getters: {
    denied: state => state.denied,
    summaryTransactions: (state) => {
      return state.summaryTransactions.slice().reverse();
    },
    currentBankBalance: (state, getters) => {
      let transaction = getters.summaryTransactions[0];
      return transaction ? transaction.bankBalance : 0
    },
    students: state => state.students,
    studentNames: state => state.students.map(s => s.name),
    staff: state => state.staff,
    accounts: state => state.accounts.sort((a, b) => {
      if (a.name > b.name) {
        return 1
      }
      else if (a.name < b.name) {
        return -1
      }
      return 0
    }),
    accountNames: (state, getters) => getters.accounts.map(s => s.name),
    user: state => state.user,
    accountsLoading: state => state.accountsLoading,
    currentAccountLoading: state => state.currentAccountLoading,
    currentAccount: state => state.currentAccount,
    currentAccountTransactions: state => state.currentAccountTransactions.sort((a, b) => {
      if (a.timestamp > b.timestamp) {
        return -1
      }
      else if (a.timestamp < b.timestamp) {
        return 1
      }
      return 0
    }),
    monthlyTransactions: state => state.monthlyTransactions.reverse(),
    monthlyLoading: state => state.monthlyLoading,
    archivedAccountsLoading: state => state.archivedAccountsLoading,
    archivedAccounts: state => state.archivedAccounts.sort((a, b) => {
      if (a.name > b.name) {
        return 1
      }
      else if (a.name < b.name) {
        return -1
      }
      return 0
    }),
    

  },
  mutations: {
    setUser(state, value) {
      state.user = value;
    },
    denied(state, value){
      state.denied = value;
    },
    accountsLoaded(state) {
      state.accountsLoading = false
    },
    accountLoaded(state) {
      state.currentAccountLoading = false
    },
    archivedAccountsLoaded(state) {
      state.archivedAccountsLoading = false
    },
    clearTransactions(state) {
      state.currentAccountTransactions = [];
    },
    monthlyLoadingState(state, payload) {
      state.monthlyLoading = payload;
    },
    ...firebaseMutations
  },
  actions: {
    bindSummaryTransactions: firebaseAction(({ bindFirebaseRef, commit }, { ref }) => {
      bindFirebaseRef('summaryTransactions', ref, {
        errorCallback: (err) => {
          console.log(err)
          commit('denied', true)
        },
        readyCallback: () => {
          commit('denied',false);
        }
      });
    }),
    bindStudents: firebaseAction(({ bindFirebaseRef }, { ref }) => {
      bindFirebaseRef('students', ref);
    }),
    bindStaff: firebaseAction(({ bindFirebaseRef }, { ref }) => {
      bindFirebaseRef('staff', ref);
    }),
    bindCurrentAccount: firebaseAction(({ bindFirebaseRef, commit }, { ref }) => {
      bindFirebaseRef('currentAccount', ref, {
        readyCallback: () => {
          commit('accountLoaded')
        }
      });
    }),
    bindCurrentTransactions: firebaseAction(({ bindFirebaseRef }, { ref }) => {
      bindFirebaseRef('currentAccountTransactions', ref);

    }),
    bindAccounts: firebaseAction(({ bindFirebaseRef, commit }, { ref }) => {
      bindFirebaseRef('accounts', ref, {
        readyCallback: () => {
          commit('accountsLoaded')
        }
      });
    }),
    login({ commit }, payload) {
      commit('setUser', payload);
    },
    setMonthlyTransactions: firebaseAction(({ bindFirebaseRef, commit }, { ref }) => {
      commit('monthlyLoadingState', true)
      bindFirebaseRef('monthlyTransactions', ref, {
        readyCallback: () => {
          commit('monthlyLoadingState', false)
        }
      });
    }),
    loadArchivedAccounts: firebaseAction(({ bindFirebaseRef, commit }, { ref }) => {
      bindFirebaseRef('archivedAccounts', ref, {
        readyCallback: () => {
          commit('archivedAccountsLoaded');
        }
      });
    }),
  }

})
